// extracted by mini-css-extract-plugin
export default {"wrapper":"_602590e1","horizontal":"_cbe8254c","vertical":"_7c31dfe0","carousel":"_79dc7382","slide":"_7a3d0705","none":"_2a4108b8"};